import { setUser } from 'auth';
import Spinner from 'components-stateless/Spinner';
import { API_CHECK_LOGIN } from 'constants/appConstants';
import axios from 'constants/axios';
import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { clearUser, setUserInfo } from 'utils/datadogRUM';
import { FEATURE_AUTH_FRONTEND_CUTOVER } from 'utils/flags/constants';
import { useFlag } from 'utils/flags/hooks';
import { getUnleashClient } from 'utils/flags/unleashClient';

export const ProtectedRouteGuard = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [isAuthenticated, setIsAuthenticated] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(true);
  const navigate = useNavigate();
  // TODO DEV-21196: drop useFlag and hardcode loginPath to '/auth/login' once cutover complete
  const useNewAuthFrontend = useFlag(FEATURE_AUTH_FRONTEND_CUTOVER);
  const loginPath = useNewAuthFrontend ? '/auth/login' : '/login';

  React.useEffect(() => {
    axios
      .get(API_CHECK_LOGIN)
      .then(async (response) => {
        if (response.status === 200) {
          setUser(response.data.user);
          setIsAuthenticated(true);

          // set user info in datadog
          setUserInfo({
            id: response.data.user.uuid,
            email: response.data.user.email,
            name: response.data.user.name,
            accountId: response.data.user.accountUUID,
            accountName: response.data.user.accountName,
            roleId: response.data.user.roleId,
          });

          // update unleash client context with the user
          // so feature flags that are account specific work.
          const client = getUnleashClient();
          await client.updateContext({
            userId: response.data.user.uuid,
            properties: {
              accountId: response.data.user.accountUUID,
              accountName: response.data.user.accountName,
              email: response.data.user.email,
            },
          });
          return;
        }
        clearUser();
        navigate(loginPath);
      })
      .catch(() => {
        clearUser();
        navigate(loginPath);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [navigate, loginPath]);

  if (isLoading) {
    return <Spinner />;
  }

  return isAuthenticated ? <>{children}</> : <Navigate to={loginPath} />;
};
